/**
 * Pure mapping between the VisionLocation proto messages (Timestamp instants,
 * hex-string ObjectIds) and the legacy `category` shape the artboard/sidebar UI reads
 * (`id`, `name`, `address`, `sort_order`, `image_count`, `created_at`, `updated_at`).
 *
 * `image_count` is always 0: the UI's `Number(x || 0)` guards tolerate a missing
 * count, so this adapter does not need to read it from the wire. The legacy
 * `project_id` field is not part of the proto VisionLocation (it would be a redundant
 * round-trip of the request input); callers carry it from context.
 */

import { timestampDate } from '@bufbuild/protobuf/wkt';

function isoOrNull(timestamp) {
  return timestamp ? timestampDate(timestamp).toISOString() : null;
}

export function locationToCategory(location, projectId) {
  return {
    id: location.locationId,
    project_id: projectId,
    name: location.name,
    address: location.address,
    sort_order: location.sortOrder,
    image_count: 0,
    created_at: isoOrNull(location.createdAt),
    updated_at: isoOrNull(location.updatedAt),
  };
}

export function listLocationsResponseToCategories(response, projectId) {
  return (response.result?.items || []).map((item) =>
    locationToCategory(item, projectId)
  );
}

export function createdLocationIdToCategory({ locationId, projectId, name, address, sortOrder }) {
  return {
    id: locationId,
    project_id: projectId,
    name,
    address: address || '',
    sort_order: sortOrder,
    image_count: 0,
    created_at: new Date().toISOString(),
    updated_at: null,
  };
}
